import { isObject } from '../public/utils/assertFunctions';
import { jsonObjectClone } from '../public/utils/jsonClone/jsonClone';

export const generateMismatchLog = (
  argName: string,
  argType: string,
): string => {
  return `Expected "${argName}" argument to be of type "object", but got "${argType}".`;
};

export type SomeObject = Record<string, unknown>;

export const overwriteIfPrimitiveMatch = (
  target: SomeObject,
  override: SomeObject,
  canAddProperties = false,
): SomeObject => {
  const output = jsonObjectClone(target);
  for (const [key, val] of Object.entries(override)) {
    if (!(key in target)) {
      if (canAddProperties) output[key] = val;
      continue;
    }
    if (isObject(val) && isObject(target[key])) {
      output[key] = overwriteIfPrimitiveMatch(
        target[key] as SomeObject,
        val,
        canAddProperties,
      );
    }
    if (!isObject(val) && !isObject(target[key])) {
      output[key] = val;
    }
  }
  return output;
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const overwriteObject = <T extends SomeObject>(
  target: SomeObject,
  override: SomeObject,
  canAddProperties = false,
): T => {
  if (!isObject(target)) {
    throw new Error(generateMismatchLog('target', typeof target));
  }
  if (!isObject(override)) {
    console.warn(
      generateMismatchLog('override', typeof override),
      'Returning target unchanged.',
    );
    return target as T;
  }

  return overwriteIfPrimitiveMatch(target, override, canAddProperties) as T;
};
